var _path, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Icon Set",
    viewBox: "0 0 24 30",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.71,13.71A7.5,7.5,0,1,0,7,9.18,6.5,6.5,0,0,0,3.1,19.12L2.19,21.2a.5.5,0,0,0,.66.66l2.08-.93a6.5,6.5,0,0,0,9.9-4,7.43,7.43,0,0,0,3.84-1.24l2.46,1.1a.51.51,0,0,0,.56-.1.5.5,0,0,0,.11-.56ZM8.5,21a5.46,5.46,0,0,1-3.23-1,.5.5,0,0,0-.5-.05l-1.15.51.51-1.15a.5.5,0,0,0-.06-.5A5.5,5.5,0,1,1,8.5,21Zm10.31-6.29a.5.5,0,0,0-.5.05A6.43,6.43,0,0,1,15,16c0-.15,0-.31,0-.46A6.51,6.51,0,0,0,8.5,9L8,9a6.5,6.5,0,1,1,11.71,4.34.5.5,0,0,0-.06.5l.68,1.54Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Nathan Gathright")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 44,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.c5d2371ab63ac5a419baabeb58bdb664.svg";
export { ForwardRef as ReactComponent };